import { render, staticRenderFns } from "./BettingArea.vue?vue&type=template&id=13ceba91&"
import script from "./BettingArea.vue?vue&type=script&lang=js&"
export * from "./BettingArea.vue?vue&type=script&lang=js&"
import style0 from "./BettingArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports